import { defineStore } from 'pinia'

interface MedicalScheme {}

export const useMedicalSchemesStore = defineStore('medicalSchemesStore', {
  state: () => ({
    medicalSchemes: [] as MedicalScheme[],
    medicalScheme: undefined as MedicalScheme | null,
  }),
  actions: {
    
    setMedicalScheme(medicalScheme: MedicalScheme) {
      this.medicalScheme = medicalScheme
    },

    setMedicalSchemes(medicalSchemes: MedicalScheme[]) {
      this.medicalSchemes = medicalSchemes
    }
  },
  getters: {}
})